import { buildNodeIndexToObjectMap } from "./modelvista_runtime.js";

export async function createModelVistaBindings(gltf, root, sceneIndex = 0) {
    const materialsByName = new Map(), materialsByIndex = new Map(), primitiveIndexByMesh = new WeakMap();
    root.traverse(node => {
        if (!node.isMesh) return;
        node.castShadow = true; node.receiveShadow = true;
        const association = gltf.parser?.associations?.get(node);
        if (Number.isInteger(association?.primitives)) primitiveIndexByMesh.set(node, association.primitives);
        for (const material of Array.isArray(node.material) ? node.material : [node.material]) {
            if (material?.name) materialsByName.set(material.name, material);
            const index = gltf.parser?.associations?.get(material)?.materials;
            if (Number.isInteger(index)) materialsByIndex.set(index, material);
        }
    });
    // State options can reference standard materials that aren't assigned to a
    // primitive in the initial appearance. Load those dependencies explicitly.
    const containers = gltf.parser?.json?.extensions?.INNOWORKS_configurables?.Containers ?? [];
    const referencedNames = new Set(containers.flatMap(c => (c.Material?.Options ?? []).map(o => o.MaterialName)));
    await Promise.all((gltf.parser?.json?.materials ?? []).map(async (definition, index) => {
        if (!referencedNames.has(definition.name) || materialsByIndex.has(index)) return;
        const material = await gltf.parser.getDependency("material", index);
        materialsByIndex.set(index, material);
        if (definition.name) materialsByName.set(definition.name, material);
    }));
    return { nodeIndexToObject: buildNodeIndexToObjectMap(gltf, sceneIndex), materialsByName, materialsByIndex, primitiveIndexByMesh };
}
